import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVertexai = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 512 512",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-2,.cls-3,.cls-4,.cls-5{stroke-width:0}.cls-2{fill:#34a853}.cls-3{fill:#4285f4}.cls-4{fill:#ea4335}.cls-5{fill:#fbbc04}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "bounding_box",
			children: /* @__PURE__ */ _jsx("path", {
				id: "bounding_box-2",
				d: "M0 0h512v512H0z",
				style: {
					strokeWidth: 0,
					fill: "none"
				}
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "art_layer",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M128 249c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16v105c0 8.8-7.2 16-16 16Z",
					className: "cls-4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256 464c-3 0-6-.8-8.6-2.5l-176-112c-7.5-4.7-9.7-14.6-4.9-22.1 4.8-7.5 14.6-9.6 22.1-4.9L256 429l167.4-106.5c7.5-4.7 17.3-2.5 22.1 4.9 4.7 7.5 2.5 17.3-4.9 22.1l-176 112c-2.6 1.7-5.6 2.5-8.6 2.5Z",
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M256 394c-8.8 0-16-7.2-16-16v-73.1c0-8.8 7.2-16 16-16s16 7.2 16 16V378c0 8.8-7.2 16-16 16Z",
					className: "cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128,
					cy: 64,
					r: 16,
					className: "cls-4"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 128,
					cy: 297,
					r: 16,
					className: "cls-4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M384.2 314c-8.8 0-16-7.1-16-16l-.2-106c0-8.8 7.1-16 16-16 8.8 0 16 7.1 16 16l.2 106c0 8.8-7.1 16-16 16Z",
					className: "cls-3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 384,
					cy: 64,
					r: 16,
					className: "cls-3"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 384,
					cy: 128,
					r: 16,
					className: "cls-3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M320 225c-8.8 0-16-7.2-16-16V106c0-8.8 7.2-16 16-16s16 7.2 16 16v103c0 8.8-7.2 16-16 16Z",
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 256,
					cy: 177,
					r: 16,
					className: "cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 256,
					cy: 241,
					r: 16,
					className: "cls-2"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 320,
					cy: 273,
					r: 16,
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 320,
					cy: 337,
					r: 16,
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192 225c-8.8 0-16-7.2-16-16V106c0-8.8 7.2-16 16-16s16 7.2 16 16v103c0 8.8-7.2 16-16 16Z",
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192,
					cy: 273,
					r: 16,
					className: "cls-5"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 192,
					cy: 337,
					r: 16,
					className: "cls-5"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgVertexai);
export { ForwardRef as ReactComponent };
